export class PartnerHelper {
  static isPoha(email: string): boolean {
    return /^verification.*@pohahouse.com$/.test(email);
  }

  static isMoringa(email: string): boolean {
    return email === 'moringa@rentcard.id';
  }
}
